// @flow
import type {
  SoilJob,
} from 'hfty-model-soil-jobs/types'

// Libs
import _find from 'lodash/find'

// Utils
import traverse from 'fc-utils/traverse'

// Libs
import { createSelector } from 'reselect'

// selectors
import { jobs$ } from 'hfty-soil-jobs'

// Constants
import {
  PROP_SOIL_JOB_ID,
  PROP_FIELD,
} from 'hfty-model-soil-jobs'

// Local
const path$ = traverse(['router', 'location', 'pathname'])

export default createSelector(
  [path$, jobs$],
  function (path: string, jobs: Array<SoilJob>): ?string {
    const match = `${path || ''}`.match(/recommendations\/(\d+)/)
    if (match && match.length > 1) {
      const JobId = Number(match[1])
      const job = _find(jobs, (job: SoilJob): boolean => {
        return job[PROP_SOIL_JOB_ID] === JobId
      })
      return job ? job[PROP_FIELD] : null
    }

    return null
  }
)
